// Customer Action Matrix - Main Configuration
// Imports and combines all customer action modules

import { customerBuyItemActions } from './buyItemActions';
import { customerRentalItemActions } from './rentalItemActions';
import { customerFulfillmentGroupActions } from './fulfillmentGroupActions';
import { evaluateConditions } from '../shared/conditionEvaluator';

export const customerActionMatrix = {
  // Order Item Level Actions - combines buy and rental actions
  orderItem: [
    ...customerBuyItemActions,
    ...customerRentalItemActions
  ],

  // Fulfillment Group Level Actions
  fulfillmentGroup: customerFulfillmentGroupActions
};

// Re-export condition evaluator for backward compatibility
export { evaluateConditions };

export default customerActionMatrix; 